import React from 'react';
import { Button, Card, Image } from 'antd';
import { useTranslation } from 'react-i18next';

export const HeroSection = () => {
  const { t } = useTranslation();

  return (
    <Card
      id="home"
      className="bg-world-pattern mt-[100px] bg-white
      w-full max-w-[1204px] text-center
      rounded-[24px] shadow-md
      px-4 py-6 md:px-8 md:py-10
      font-archivo scroll-mt-[200px] sm:scroll-mt-[330px] lg:scroll-mt-[120px]
    "
    >
      <h1 className="text-4xl font-bold leading-tight">
        {t('hero.title')}{' '}
        <span className="text-blue-600">{t('hero.spam')}</span>
        <br />
        {t('hero.subTitle')}
      </h1>
      <p className="text-gray-600 mt-4 max-w-xl mx-auto">
        {t('hero.description')}
      </p>
      <div className="mt-6 px-6 md:px-10 flex flex-wrap justify-center gap-3">
        <Button
          type="primary"
          href="#contact"
          className="!flex !justify-center !items-center
                        !px-8 !py-3 !gap-1
                        !w-[199px] !h-[56px]
                        !bg-[#005FCC] !text-white
                        !rounded-full
                        !text-base !font-medium
                        hover:!bg-[#004bb0] transition-colors"
        >
          {t('common.contact')}
          <Image
            preview={false}
            src="/images/icons/arrow-right.svg"
            alt="arrow"
          />
        </Button>
      </div>
    </Card>
  );
};
